import script from "./WhiteBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./WhiteBox.vue?vue&type=script&lang=ts&setup=true"

import "./WhiteBox.vue?vue&type=style&index=0&id=1f63fb26&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f63fb26"]])

export default __exports__